import { DependenciesInjection } from "app/di/DependencyInjection";
import { NiceSimRegistrationImpl } from "features/niceSimRegistration/data/NiceSimRegistrationImpl";
import { INiceSimRegistrationRepository } from "features/niceSimRegistration/domain/repositories/INiceSimRegistrationRepository";
import { NiceSimRegistrationUseCase } from "features/niceSimRegistration/domain/useCases/NiceSimRegistrationUseCase";
import { NiceSimRegistrationViewModel } from "features/niceSimRegistration/presentation/viewModel/NiceSimRegistrationViewModel";
import { NiceSimRegistrationToken } from "features/niceSimRegistration/di/NiceSimRegistrationToken";

export class NiceSimRegistrationInjection {
  static initInjections(): void {
    DependenciesInjection.register<INiceSimRegistrationRepository>(
      NiceSimRegistrationToken.INiceSimRegistrationRepository,
      NiceSimRegistrationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<NiceSimRegistrationUseCase>(
      NiceSimRegistrationToken.NiceSimRegistrationUseCase,
      NiceSimRegistrationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<NiceSimRegistrationViewModel>(
      NiceSimRegistrationToken.NiceSimRegistrationViewModel,
      NiceSimRegistrationViewModel,
      "viewModel",
    );
  }

  static getNiceSimRegistrationRepo(): INiceSimRegistrationRepository {
    return DependenciesInjection.getRepo<INiceSimRegistrationRepository>(
      NiceSimRegistrationToken.INiceSimRegistrationRepository,
    );
  }

  static getNiceSimRegistrationUseCase(): NiceSimRegistrationUseCase {
    return DependenciesInjection.getRepo<NiceSimRegistrationUseCase>(
      NiceSimRegistrationToken.NiceSimRegistrationUseCase,
    );
  }
}
